import * as Actions from 'reducks/shop/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const ShopReducer = (state = initialState.shop, action: any) => {
  switch (action.type) {
    case Actions.FETCH_SHOP:
      return {
        ...state,
        ...action.payload,
      }
    case Actions.INIT_SHOP:
      return {
        ...initialState.shop,
      }
    case Actions.REGISTER_CARD:
      return {
        ...state,
        ...action.payload,
      }
    case Actions.RETRIEVE_CARD:
      return {
        ...state,
        card: { ...action.payload },
      }
    case Actions.SAVE_SHOP:
      return {
        ...state,
        ...action.payload,
      }

    default:
      return state
  }
}
